// import React, { useState, useEffect } from "react";
// import axiosInstance from "../api/axios";
// import {
//   Elements,
//   PaymentElement,
//   useStripe,
//   useElements,
// } from "@stripe/react-stripe-js";
// import { motion } from "framer-motion";
// import logo from "../images/logo.png";
// import { NavLink, useNavigate } from "react-router-dom";
// import Navbarsmall from "../components/Navbarsmall";
// import { useAuth } from "../components/AuthContext";
// import { loadStripe } from "@stripe/stripe-js";
// function Account() {
//   const [subscriptions, setSubscriptions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [canceling, setCanceling] = useState(false);
//   const [cancelError, setCancelError] = useState(null);
//   const [cancelSuccess, setCancelSuccess] = useState(false);
//   const [updatingPayment, setUpdatingPayment] = useState(false);
//   const [updateError, setUpdateError] = useState(null);
//   const [updateSuccess, setUpdateSuccess] = useState(false);
//   const [selectedSubscription, setSelectedSubscription] = useState(null);
//   const [creatingSubscription, setCreatingSubscription] = useState(false);
//   const [showCancelPopup, setShowCancelPopup] = useState(false);
//   const [cancelingSubscriptionId, setCancelingSubscriptionId] = useState(null);
//   const [subscriptionCreationError, setSubscriptionCreationError] =
//     useState(null);
//   const [subscriptionCreationSuccess, setSubscriptionCreationSuccess] =
//     useState(false);

//   const [clientSecret, setClientSecret] = useState(null);

//   const stripe = useStripe();
//   const elements = useElements();

//   const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

//   const { logout } = useAuth();
//   const navigate = useNavigate();
//   const handleLogout = () => {
//     logout();
//     navigate("/");
//   };

//   useEffect(() => {
//     async function fetchSubscriptions() {
//       const userEmail = localStorage.getItem("userEmail");

//       if (!userEmail) {
//         setError("Please log in to view your subscriptions");
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await axiosInstance.get(
//           `/subscriptions?email=${userEmail}`
//         );
//         setSubscriptions(response.data.subscriptions?.data || []);
//       } catch (err) {
//         setError(
//           err.response
//             ? err.response.data.message
//             : "Failed to fetch subscriptions"
//         );
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchSubscriptions();
//   }, []);

//   const handleCancel = async (subscriptionId) => {
//     setCanceling(true);
//     setCancelError(null);
//     setCancelSuccess(false);

//     try {
//       const userEmail = localStorage.getItem("userEmail");
//       const response = await axiosInstance.post("/cancel-subscription", {
//         subscription_id: subscriptionId,
//         email: userEmail,
//       });

//       if (response.data.message === "Subscription canceled successfully") {
//         setCancelSuccess(true);
//         setSubscriptions((prevSubscriptions) =>
//           prevSubscriptions.filter((sub) => sub.id !== subscriptionId)
//         );
//       }
//     } catch (error) {
//       setCancelError(
//         error.response
//           ? error.response.data.detail
//           : "Failed to cancel subscription"
//       );
//     } finally {
//       setCanceling(false);
//     }
//   };

//   const handleCreateSubscription = async () => {
//     setCreatingSubscription(true);
//     setSubscriptionCreationError(null);
//     setSubscriptionCreationSuccess(false);

//     const userEmail = localStorage.getItem("userEmail");
//     const priceId = "price_1SpBOi046YZkLcO5SDUsSyB4";

//     if (!userEmail) {
//       setSubscriptionCreationError("Please log in to create a subscription.");
//       setCreatingSubscription(false);
//       return;
//     }

//     try {
//       const checkoutResponse = await axiosInstance.post(
//         "/create-subscription",
//         {
//           email: userEmail,
//           priceId,
//         }
//       );

//       const { sessionId } = checkoutResponse.data;

//       const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
//       const { error } = await stripe.redirectToCheckout({ sessionId });

//       if (error) {
//         setSubscriptionCreationError(error.message);
//       }

//       if (checkoutResponse.data.subscription) {
//         setSubscriptionCreationSuccess(true);
//         setSubscriptions((prevSubscriptions) => [
//           ...prevSubscriptions,
//           checkoutResponse.data.subscription,
//         ]);
//       }
//     } catch (error) {
//       setSubscriptionCreationError(
//         error.response
//           ? error.response.data.detail
//           : "Failed to create subscription"
//       );
//     } finally {
//       setCreatingSubscription(false);
//     }
//   };

//   const handleCancelClick = (subscriptionId) => {
//     setCancelingSubscriptionId(subscriptionId);
//     setShowCancelPopup(true);
//   };

//   const handleCancelSubscriptionConfirm = () => {
//     if (cancelingSubscriptionId) {
//       handleCancel(cancelingSubscriptionId);
//     }
//     setShowCancelPopup(false);
//     setCancelingSubscriptionId(null);
//   };

//   const handleCancelSubscriptionClose = () => {
//     setShowCancelPopup(false);
//     setCancelingSubscriptionId(null);
//   };

//   const handleUpdateClick = async (subscription) => {
//     console.log("Update clicked for subscription:", subscription);
//     setSelectedSubscription(subscription);

//     try {
//       const response = await axiosInstance.post("/create-setup-intent", {
//         customer_id: subscription.customer,
//       });
//       console.log("Setup intent response:", response.data);
//       setClientSecret(response.data.clientSecret);
//     } catch (err) {
//       console.error("Failed to create setup intent:", err);
//     }
//   };
//   const PaymentForm = ({
//     selectedSubscription,
//     setSelectedSubscription,
//     setSubscriptions,
//   }) => {
//     const stripe = useStripe();
//     const elements = useElements();

//     const [updatingPayment, setUpdatingPayment] = useState(false);
//     const [updateError, setUpdateError] = useState(null);
//     const [updateSuccess, setUpdateSuccess] = useState(false);

//     const handleUpdatePayment = async () => {
//       if (!stripe || !elements || !selectedSubscription) return;

//       setUpdatingPayment(true);
//       setUpdateError(null);
//       setUpdateSuccess(false);

//       try {
//         const { setupIntent, error } = await stripe.confirmSetup({
//           elements,
//           confirmParams: {
//             return_url: window.location.href,
//           },
//           redirect: "if_required",
//         });

//         if (error) {
//           setUpdateError(error.message);
//           setUpdatingPayment(false);
//           return;
//         }

//         const paymentMethodId = setupIntent?.payment_method;

//         // Call backend to update subscription
//         const response = await axiosInstance.post("/update-payment-method", {
//           subscription_id: selectedSubscription.id,
//           payment_method_id: paymentMethodId,
//         });

//         if (response.data.message === "Payment method updated successfully.") {
//           setUpdateSuccess(true);
//           setSubscriptions((prev) =>
//             prev.map((sub) =>
//               sub.id === selectedSubscription.id
//                 ? { ...sub, default_payment_method: { id: paymentMethodId } }
//                 : sub
//             )
//           );
//         } else {
//           setUpdateError("Failed to update payment method on the server.");
//         }
//       } catch (err) {
//         setUpdateError(
//           err.response?.data?.detail || "Failed to update payment method."
//         );
//       } finally {
//         setUpdatingPayment(false);
//         setTimeout(() => {
//           setSelectedSubscription(null);
//           setUpdateSuccess(false);
//         }, 4000);
//       }
//     };

//     return (
//       <div className="mt-8 mb-6">
//         <h3 className="text-2xl text-[#000000]">Updating Payment Method</h3>

//         <div className="mt-4">
//           <PaymentElement />
//         </div>

//         <div className="mt-4">
//           <button
//             type="button"
//             onClick={handleUpdatePayment}
//             className="bg-[#7b6b52] text-white py-2 px-4 rounded-full mb-6 hover:bg-[#6a5e46]"
//             disabled={updatingPayment || !stripe || !elements}
//           >
//             {updatingPayment ? "Updating..." : "Confirm Update"}
//           </button>
//         </div>

//         {updateError && <p className="text-red-600">{updateError}</p>}
//         {updateSuccess && (
//           <p className="text-green-600">Payment method updated successfully!</p>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="flex   h-screen">
//       <span className="block xl:hidden">
//         <Navbarsmall />
//       </span>
//       <motion.nav
//         // initial={{ x: "-100%" }}
//         // animate={{ x: 0 }}
//         // transition={{ duration: 0.5 }}
//         className="fixed top-0 left-0 h-full w-1/8  md:w-1/8 bg-[#f5ede7] space-y-8 z-50 xl:block hidden"
//       >
//         <div className="text-4xl font-bold text-center text-gray-800">
//           <a href="/" target="_blank" rel="noopener noreferrer">
//             <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
//           </a>
//         </div>
//         <motion.ul
//           // initial={{ opacity: 0 }}
//           // animate={{ opacity: 1 }}
//           // transition={{ duration: 0.8 }}
//           className="space-y-4 text-[#967d6c] font-semibold"
//         >
//           <motion.li
//             // initial={{ x: -20, opacity: 0 }}
//             // animate={{ x: 0, opacity: 1 }}
//             // transition={{ duration: 0.6 }}
//             className="w-full"
//           >
//             <NavLink
//               to="/furhome"
//               className={({ isActive }) =>
//                 isActive
//                   ? "bg-[#967d6c] text-white w-full px-4 py-2 text-xl block"
//                   : "hover:text-gray-800 w-full px-4 py-2 text-xl block"
//               }
//             >
//               Home
//             </NavLink>
//           </motion.li>

//           <motion.li
//             // initial={{ x: -20, opacity: 0 }}
//             // animate={{ x: 0, opacity: 1 }}
//             // transition={{ duration: 0.7 }}
//             className="w-full"
//           >
//             <NavLink
//               to="/pet-health"
//               className={({ isActive }) =>
//                 isActive
//                   ? "bg-[#967d6c] text-white w-full px-4 py-2 text-xl block "
//                   : "hover:text-gray-800 text-left w-full px-4 py-2 text-xl block "
//               }
//             >
//                Pet Health
//             </NavLink>
//           </motion.li>
//           <motion.li
//             // initial={{ x: -20, opacity: 0 }}
//             // animate={{ x: 0, opacity: 1 }}
//             // transition={{ duration: 0.8 }}
//             className="w-full"
//           >
//             <NavLink
//               to="/pet-nutrition"
//               className={({ isActive }) =>
//                 isActive
//                   ? "bg-[#967d6c] text-white w-full px-4 py-2 rounded-md text-xl"
//                   : "hover:text-gray-800 text-left w-full px-4 py-2 text-xl"
//               }
//             >
//               Pet Nutrition
//             </NavLink>
//           </motion.li>
//         </motion.ul>

//         <motion.div
//           // initial={{ opacity: 0 }}
//           // animate={{ opacity: 1 }}
//           // transition={{ duration: 0.8 }}
//           className="w-full"
//         >
//           <NavLink
//             to="#"
//             onClick={handleLogout}
//             className="hover:text-gray-800 text-[#967d6c] poppins-text w-full px-4 py-2 mt-96 text-xl bg-transparent focus:outline-none text-center block"
//           >
//             Logout
//           </NavLink>
//         </motion.div>
//       </motion.nav>
//       <div className="flex-1  ml-[12.5%] mt-24  p-6">
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.5 }}
//         >
//           <div className="flex  justify-between mt-6 items-center mb-6">
//             <h1 className="xl:text-5xl text-3xl mr-1  font-semibold text-[#000000]">
//               Your Information
//             </h1>
//             <button
//               onClick={handleCreateSubscription}
//               className={`py-2 px-4 rounded-full text-white ${
//                 creatingSubscription ||
//                 subscriptions.some((sub) => sub.status === "active")
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-[#967d6c] hover:bg-[#7b6b52]"
//               }`}
//               disabled={
//                 creatingSubscription ||
//                 subscriptions.some((sub) => sub.status === "active")
//               }
//             >
//               Create New Subscription
//             </button>
//           </div>

//           {loading ? (
//             <div className="text-center mt-6">
//               <div className="animate-spin rounded-full h-24 w-24 border-t-4 border-[#967d6c] mx-auto mb-4"></div>
//               <p>Loading subscriptions...</p>
//             </div>
//           ) : error ? (
//             <div className="text-center mt-6 text-red-500">{error}</div>
//           ) : (
//             <>
//               <h2 className="xl:text-4xl text-2xl  font-semibold mb-4 text-[#000000]">
//                 Subscriptions
//               </h2>
//               {subscriptions.length > 0 ? (
//                 <div>
//                   {subscriptions.map((subscription) => {
//                     const trialDaysLeft =
//                       subscription.trial_end &&
//                       subscription.trial_end > Date.now() / 1000
//                         ? Math.ceil(
//                             (subscription.trial_end - Date.now() / 1000) /
//                               (60 * 60 * 24)
//                           )
//                         : 0;

//                     return (
//                       <div
//                         key={subscription.id}
//                         className="mb-10 p-4 border bg-white rounded-lg w-auto"
//                       >
//                         <div className="flex justify-between items-start">
//                           <h2 className="text-2xl font-semibold">
//                             Furbabies.AI
//                           </h2>
//                           <p className="text-lg font-bold">
//                             $4.99
//                             <span className="text-sm text-[#967D6C]">
//                               /month
//                             </span>
//                           </p>
//                         </div>
//                         <p className="poppins-text">
//                           Plan: {subscription.status}
//                         </p>
//                         <p className="poppins-text">
//                           Card Last 4 Digits:{" ****"}
//                           {subscription.default_payment_method?.card?.last4 ||
//                             "N/A"}
//                         </p>
//                         {/* <p className="poppins-text">
//                           Start Date:{" "}
//                           {new Date(
//                             subscription.start_date * 1000
//                           ).toLocaleString()}
//                         </p> */}
//                         {/* <p className="poppins-text">
//                           Billing Interval: {subscription.plan.interval}
//                         </p> */}
//                         <p className="poppins-text">
//                           Next Billing Date:{" "}
//                           {subscription.status !== "canceled"
//                             ? new Date(
//                                 subscription.current_period_end * 1000
//                               ).toLocaleString()
//                             : "N/A"}
//                         </p>
//                         <p className="poppins-text">
//                           Trial Days Left:{" "}
//                           {trialDaysLeft > 0 ? trialDaysLeft : "N/A"}
//                         </p>
//                         {subscription.status !== "canceled" && (
//                           <div className="mt-4">
//                             <button
//                               onClick={() => {
//                                 setSelectedSubscription(subscription);
//                                 handleUpdateClick(subscription);
//                               }}
//                               className="bg-[#ffffff] text-black poppins-text border border-[#BDA697] py-2 px-4 rounded-full "
//                               disabled={updatingPayment}
//                             >
//                               Update Payment Method
//                             </button>
//                             <button
//                               onClick={() => handleCancelClick(subscription.id)}
//                               className="bg-[#e88c4f] xl:mx-6 mt-2 text-white poppins-text py-2 px-4 mb-4 hover:bg-[#eab48f] rounded-full  mr-4"
//                               disabled={canceling}
//                             >
//                               Cancel Subscription
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//                   {showCancelPopup && (
//                     <div className="fixed inset-0 text-center  bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
//                       <div className="bg-white rounded-lg p-6 w-auto shadow-lg">
//                         <h2 className="text-xl font-semibold mb-4 text-gray-900">
//                           Cancel Subscription
//                         </h2>
//                         <p className="text-gray-700 poppins-text  mb-6">
//                           Are you sure you want to cancel your subscription?
//                         </p>
//                         <div className="flex justify-end space-x-4">
//                           <button
//                             onClick={handleCancelSubscriptionClose}
//                             className=" bg-[#ffffff] text-black poppins-text  border py-2 px-4 rounded-full hover:bg-[#ffffff]"
//                           >
//                             No, stay subscribed
//                           </button>
//                           <button
//                             onClick={handleCancelSubscriptionConfirm}
//                             className="bg-[#e88c4f] text-white px-4 poppins-text  py-2 rounded-full hover:bg-[#eab48f]"
//                           >
//                             Yes, cancel my subscription
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <p>You have no active subscriptions.</p>
//               )}

//               {selectedSubscription && clientSecret && (
//                 <Elements stripe={stripePromise} options={{ clientSecret }}>
//                   <PaymentForm
//                     selectedSubscription={selectedSubscription}
//                     setSelectedSubscription={setSelectedSubscription}
//                     setSubscriptions={setSubscriptions}
//                   />
//                 </Elements>
//               )}
//             </>
//           )}

//           {creatingSubscription && (
//             <div className="text-center mt-4">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#967d6c] mx-auto mb-2"></div>
//               <p>Creating subscription...</p>
//             </div>
//           )}

//           {subscriptionCreationError && (
//             <div className="mt-4 text-center text-red-500">
//               {subscriptionCreationError}
//             </div>
//           )}

//           {subscriptionCreationSuccess && (
//             <div className="mt-4 text-center text-green-500">
//               Subscription created successfully.
//             </div>
//           )}
//         </motion.div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axiosInstance from "../api/axios";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../images/logo.png";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Navbarsmall from "../components/Navbarsmall";
import { useAuth } from "../components/AuthContext";

// ─── Fade-up animation variant ───────────────────────────────────────────────
const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay, ease: "easeOut" },
});

// ─── Toast notification ───────────────────────────────────────────────────────
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  const styles = {
    success: {
      bg: "bg-green-50 border-green-200",
      text: "text-green-700",
      icon: (
        <svg
          className="w-5 h-5 text-green-500 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      ),
    },
    info: {
      bg: "bg-[#f5ede7] border-[#e8ddd6]",
      text: "text-[#7a6457]",
      icon: (
        <svg
          className="w-5 h-5 text-[#967d6c] shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
  };
  const s = styles[type] || styles.info;

  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -16 }}
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-5 py-3.5 rounded-2xl border shadow-lg max-w-sm w-full ${s.bg}`}
    >
      {s.icon}
      <span className={`text-sm poppins-text font-medium ${s.text}`}>
        {message}
      </span>
      <button
        onClick={onClose}
        className="ml-auto text-gray-400 hover:text-gray-600"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </motion.div>
  );
};

// ─── Status badge ─────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const map = {
    active: {
      bg: "bg-green-50",
      text: "text-green-700",
      dot: "bg-green-500",
      label: "Active",
    },
    trialing: {
      bg: "bg-blue-50",
      text: "text-blue-700",
      dot: "bg-blue-400",
      label: "Trial",
    },
    canceled: {
      bg: "bg-red-50",
      text: "text-red-600",
      dot: "bg-red-400",
      label: "Canceled",
    },
    past_due: {
      bg: "bg-orange-50",
      text: "text-orange-600",
      dot: "bg-orange-400",
      label: "Past Due",
    },
  };
  const s = map[status] || {
    bg: "bg-gray-100",
    text: "text-gray-600",
    dot: "bg-gray-400",
    label: status,
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold poppins-text ${s.bg} ${s.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

// ─── Info row ─────────────────────────────────────────────────────────────────
const InfoRow = ({ label, value }) => (
  <div className="flex justify-between items-center py-3 border-b border-[#f0e9e4] last:border-0">
    <span className="text-sm text-gray-500 poppins-text">{label}</span>
    <span className="text-sm font-medium text-gray-800 poppins-text">
      {value}
    </span>
  </div>
);

// ─── Inline change-password form ─────────────────────────────────────────────
const EyeBtn = ({ visible, onToggle }) => (
  <button type="button" onClick={onToggle} tabIndex={-1}
    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
    {visible ? (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
      </svg>
    ) : (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    )}
  </button>
);

const PwInput = ({ label, placeholder, value, onChange, visible, onToggle }) => (
  <div>
    <label className="block text-sm font-semibold text-gray-700 mb-1.5 poppins-text">{label}</label>
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required
        className="w-full bg-[#faf7f5] border border-[#e8ddd6] rounded-xl px-4 py-2.5 pr-10 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#967d6c] poppins-text"
      />
      <EyeBtn visible={visible} onToggle={onToggle} />
    </div>
  </div>
);

function ChangePasswordForm({ defaultOpen = false, onSuccess }) {
  const [open, setOpen]       = useState(defaultOpen);
  const [form, setForm]       = useState({ current: "", next: "", confirm: "" });
  const [show, setShow]       = useState({ current: false, next: false, confirm: false });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [done, setDone]       = useState(false);

  const field = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));
  const eye   = (k) => () => setShow((p) => ({ ...p, [k]: !p[k] }));

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (form.next !== form.confirm)          { setError("New passwords do not match."); return; }
    if (form.next.length < 8)               { setError("Must be at least 8 characters."); return; }
    if (!/[A-Z]/.test(form.next))           { setError("Must contain at least one uppercase letter."); return; }
    if (!/\d/.test(form.next))              { setError("Must contain at least one number."); return; }
    setLoading(true);
    try {
      const email = localStorage.getItem("userEmail");
      await axiosInstance.post("/change-password", {
        email,
        current_password: form.current,
        new_password: form.next,
      });
      localStorage.setItem("mustChangePassword", "false");
      setDone(true);
      setForm({ current: "", next: "", confirm: "" });
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm overflow-hidden">
      <button
        type="button"
        onClick={() => { setOpen((o) => !o); setError(null); setDone(false); }}
        className="w-full px-6 py-5 flex items-center justify-between text-left"
      >
        <div>
          <h3 className="text-base font-bold text-gray-800">Password</h3>
          <p className="text-sm text-gray-500 poppins-text mt-0.5">
            Keep your account secure with a strong, unique password.
          </p>
        </div>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="pw-form"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-6 border-t border-[#f0e9e4]">
              {done ? (
                <div className="mt-5 bg-green-50 border border-green-200 rounded-xl px-4 py-3 text-center">
                  <p className="text-green-700 font-semibold poppins-text text-sm">Password changed successfully!</p>
                </div>
              ) : (
                <form onSubmit={submit} className="space-y-4 mt-5">
                  <PwInput label="Current Password"     placeholder="Your current password"           value={form.current} onChange={field("current")} visible={show.current} onToggle={eye("current")} />
                  <PwInput label="New Password"         placeholder="Min 8 chars, 1 uppercase, 1 number" value={form.next}    onChange={field("next")}    visible={show.next}    onToggle={eye("next")} />
                  <PwInput label="Confirm New Password" placeholder="Repeat new password"                value={form.confirm} onChange={field("confirm")} visible={show.confirm} onToggle={eye("confirm")} />
                  {error && (
                    <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-600 text-sm poppins-text">
                      {error}
                    </div>
                  )}
                  <motion.button
                    whileHover={{ backgroundColor: "#BDA697" }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#967d6c] text-white font-bold py-3 rounded-xl text-sm poppins-text disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center gap-2">
                        <span className="w-4 h-4 border-2 border-white border-b-transparent rounded-full animate-spin" />
                        Updating…
                      </span>
                    ) : "Update Password"}
                  </motion.button>
                </form>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

// ─── Bulk/partner access view ─────────────────────────────────────────────────
function BulkAccountView({ onLogout }) {
  const [mustChange, setMustChange] = useState(
    localStorage.getItem("mustChangePassword") === "true"
  );

  return (
    <div className="flex-1 ml-[12.5%] mt-16 p-8 overflow-y-auto">
      <motion.div {...fadeUp(0)} className="max-w-2xl mx-auto">
        <div className="mb-10 mt-8">
          <motion.h1 {...fadeUp(0.05)} className="text-5xl font-bold text-gray-900 mb-1">
            Your Account
          </motion.h1>
          <motion.p {...fadeUp(0.1)} className="text-gray-500 poppins-text text-lg">
            Furbabies.AI — Employee Benefits Access
          </motion.p>
        </div>

        {/* Access status card */}
        <motion.div
          {...fadeUp(0.12)}
          className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm overflow-hidden mb-5"
        >
          <div className="bg-[#f5ede7] px-6 py-4 flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-gray-900">Furbabies.AI</h2>
              <p className="text-sm text-gray-500 poppins-text">Employee benefits plan</p>
            </div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold poppins-text bg-green-50 text-green-700">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
              Active
            </span>
          </div>
          <div className="px-6 py-5">
            <p className="text-sm text-gray-600 poppins-text leading-relaxed">
              Your access to Furbabies.AI is provided through your employer's benefits program.
              Payments and billing are handled separately — you don't need a subscription.
            </p>
          </div>
        </motion.div>

        {/* Must-change-password banner */}
        {mustChange && (
          <motion.div
            {...fadeUp(0.16)}
            className="bg-amber-50 border border-amber-200 rounded-2xl px-6 py-4 flex items-start gap-4 mb-5"
          >
            <svg className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
            <div>
              <p className="text-sm font-semibold text-amber-800 poppins-text">
                Please change your temporary password
              </p>
              <p className="text-xs text-amber-700 poppins-text mt-0.5">
                You're using the default password. Update it below to secure your account.
              </p>
            </div>
          </motion.div>
        )}

        {/* Inline change password — auto-open on first login */}
        <motion.div {...fadeUp(0.18)}>
          <ChangePasswordForm
            defaultOpen={mustChange}
            onSuccess={() => setMustChange(false)}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}

function Account() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [portalLoading, setPortalLoading] = useState(false);
  const [portalError, setPortalError] = useState(null);
  const [creatingSubscription, setCreatingSubscription] = useState(false);
  const [subscriptionCreationError, setSubscriptionCreationError] =
    useState(null);
  const [toast, setToast] = useState(null); // { message, type }

  const isBulkUser = localStorage.getItem("bulkAccess") === "true";

  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // ── Read query params from resubscribe redirect ───────────────────────────
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("resubscribed") === "true") {
      setToast({
        message: "🎉 Welcome back! Your subscription is now active.",
        type: "success",
      });
      // Clean up URL without reload
      window.history.replaceState({}, "", "/account");
    } else if (params.get("cancelled") === "true") {
      setToast({
        message: "Checkout cancelled — you haven't been charged.",
        type: "info",
      });
      window.history.replaceState({}, "", "/account");
    }
  }, [location.search]);

  // ── Fetch subscriptions ───────────────────────────────────────────────────
  useEffect(() => {
    async function fetchSubscriptions() {
      const userEmail = localStorage.getItem("userEmail");
      if (!userEmail) {
        setError("Please log in to view your subscriptions.");
        setLoading(false);
        return;
      }
      try {
        const response = await axiosInstance.get(
          `/subscriptions?email=${userEmail}`,
        );
        setSubscriptions(response.data.subscriptions?.data || []);
      } catch (err) {
        setError(
          err.response?.data?.message || "Failed to fetch subscriptions.",
        );
      } finally {
        setLoading(false);
      }
    }
    fetchSubscriptions();
  }, []);

  // ── Open Stripe Customer Portal ───────────────────────────────────────────
  // This handles BOTH cancel and update payment in one place — Stripe's hosted UI
  const handleOpenPortal = async () => {
    setPortalLoading(true);
    setPortalError(null);
    const userEmail = localStorage.getItem("userEmail");
    try {
      const response = await axiosInstance.post("/create-portal-session", {
        email: userEmail,
        return_url: "https://www.furbabies.ai/account",
      });
      window.location.href = response.data.url;
    } catch (err) {
      setPortalError(
        err.response?.data?.detail ||
          "Failed to open billing portal. Please try again.",
      );
      setPortalLoading(false);
    }
  };

  // ── Create new subscription ───────────────────────────────────────────────
  const handleCreateSubscription = async () => {
    setCreatingSubscription(true);
    setSubscriptionCreationError(null);
    const userEmail = localStorage.getItem("userEmail");
    const priceId = "price_1SpBOi046YZkLcO5SDUsSyB4";
    if (!userEmail) {
      setSubscriptionCreationError("Please log in to create a subscription.");
      setCreatingSubscription(false);
      return;
    }
    try {
      const checkoutResponse = await axiosInstance.post(
        "/create-subscription",
        { email: userEmail, priceId },
      );
      const { sessionId } = checkoutResponse.data;
      const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
      const { error } = await stripe.redirectToCheckout({ sessionId });
      if (error) setSubscriptionCreationError(error.message);
    } catch (err) {
      setSubscriptionCreationError(
        err.response?.data?.detail || "Failed to create subscription.",
      );
    } finally {
      setCreatingSubscription(false);
    }
  };

  const hasActive = subscriptions.some(
    (s) => s.status === "active" || s.status === "trialing",
  );

  // ─────────────────────────────────────────────────────────────────────────
  if (isBulkUser) {
    return (
      <div className="flex h-screen bg-[#ffffff]">
        <span className="block xl:hidden"><Navbarsmall /></span>
        <motion.nav className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#E8E1DA] space-y-8 z-50 xl:block hidden">
          <div className="text-4xl font-bold text-center text-gray-800">
            <a href="/" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
            </a>
          </div>
          <motion.ul className="text-[#967d6c] font-semibold">
            {[
              { to: "/furhome", label: "Home" },
              { to: "/pet-health", label: "Pet Health" },
              { to: "/pet-nutrition", label: "Pet Nutrition" },
            ].map(({ to, label }) => (
              <motion.li key={to} className="w-full">
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive
                      ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
                      : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"
                  }
                >
                  {label}
                </NavLink>
              </motion.li>
            ))}
          </motion.ul>
          <div className="absolute bottom-0 w-full pb-2">
            <NavLink
              to="#"
              onClick={handleLogout}
              className="hover:text-gray-800 poppins-text text-[#967d6c] w-full px-4 py-2 text-xl bg-transparent focus:outline-none text-center block"
            >
              Logout
            </NavLink>
          </div>
        </motion.nav>
        <BulkAccountView onLogout={handleLogout} />
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-[#ffffff]">
      {/* ── Toast ── */}
      <AnimatePresence>
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}
      </AnimatePresence>

      <span className="block xl:hidden">
        <Navbarsmall />
      </span>

      {/* ── Sidebar ── */}
      {/* <motion.nav className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#f5ede7] space-y-8 z-50 xl:block hidden">
        <div className="text-4xl font-bold text-center text-gray-800">
          <a href="/" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
          </a>
        </div>
        <motion.ul className="space-y-4 text-[#967d6c] font-semibold">
          <motion.li className="w-full">
            <NavLink
              to="/furhome"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 py-2 text-xl block"
                  : "hover:bg-[#bda697] hover:text-white w-full px-4 py-2 text-xl block transition-colors"
              }
            >
              Home
            </NavLink>
          </motion.li>
          <motion.li className="w-full">
            <NavLink
              to="/pet-health"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 py-2 text-xl block"
                  : "hover:bg-[#bda697] hover:text-white w-full px-4 py-2 text-xl block transition-colors"
              }
            >
              Pet Health
            </NavLink>
          </motion.li>
          <motion.li className="w-full">
            <NavLink
              to="/pet-nutrition"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 py-2 text-xl block"
                  : "hover:bg-[#bda697] hover:text-white w-full px-4 py-2 text-xl block transition-colors"
              }
            >
              Pet Nutrition
            </NavLink>
          </motion.li>
        </motion.ul>
        <motion.div className="w-full">
          <NavLink
            to="#"
            onClick={handleLogout}
            className="hover:text-gray-800 text-[#967d6c] poppins-text w-full px-4 py-2 mt-96 text-xl bg-transparent focus:outline-none text-center block"
          >
            Logout
          </NavLink>
        </motion.div>
      </motion.nav> */}
  {/* ── Sidebar ── */}
        <motion.nav className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#E8E1DA] space-y-8 z-50 xl:block hidden">
          <div className="text-4xl font-bold text-center text-gray-800">
            <a href="/" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
            </a>
          </div>
          <motion.ul className="text-[#967d6c] font-semibold">
            {[
              { to: "/furhome", label: "Home" },
              { to: "/pet-health", label: "Pet Health" },
              { to: "/pet-nutrition", label: "Pet Nutrition" },
            ].map(({ to, label }) => (
              <motion.li key={to} className="w-full">
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive
                      ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
                      : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"
                  }
                >
                  {label}
                </NavLink>
              </motion.li>
            ))}
          </motion.ul>
          <div className="absolute bottom-0 w-full pb-2">
            <NavLink
              to="#"
              onClick={handleLogout}
              className="hover:text-gray-800 poppins-text text-[#967d6c] w-full px-4 py-2 text-xl bg-transparent focus:outline-none text-center block"
            >
              Logout
            </NavLink>
          </div>
        </motion.nav>
      {/* ── Main ── */}
      <div className="flex-1 ml-[12.5%] mt-16 p-8 overflow-y-auto">
        <motion.div {...fadeUp(0)} className="max-w-2xl mx-auto">
          {/* Page header */}
          <div className="mb-10 mt-8">
            <motion.h1
              {...fadeUp(0.05)}
              className="text-5xl font-bold text-gray-900 mb-1"
            >
              Your Account
            </motion.h1>
            <motion.p
              {...fadeUp(0.1)}
              className="text-gray-500 poppins-text text-lg"
            >
              Manage your subscription and billing details.
            </motion.p>
          </div>

          {/* ── Loading ── */}
          {loading && (
            <div className="flex flex-col items-center justify-center py-24 gap-4">
              <div className="w-12 h-12 border-4 border-[#967d6c] border-b-transparent rounded-full animate-spin" />
              <p className="text-gray-500 poppins-text">
                Loading your account…
              </p>
            </div>
          )}

          {/* ── Error ── */}
          {!loading && error && (
            <motion.div
              {...fadeUp(0.1)}
              className="bg-red-50 border border-red-200 text-red-700 rounded-2xl px-6 py-4 poppins-text text-sm"
            >
              {error}
            </motion.div>
          )}

          {/* ── No subscriptions ── */}
          {!loading && !error && subscriptions.length === 0 && (
            <motion.div
              {...fadeUp(0.1)}
              className="bg-white border border-[#e8ddd6] rounded-2xl p-10 text-center shadow-sm"
            >
              <div className="w-16 h-16 bg-[#f5ede7] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 text-[#967d6c]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                No active subscription
              </h3>
              <p className="text-gray-500 poppins-text mb-6 text-sm">
                Get full access to Furbabies.AI for your pet's health and
                nutrition needs.
              </p>
              <motion.button
                whileHover={{ backgroundColor: "#BDA697" }}
                whileTap={{ scale: 0.97 }}
                onClick={handleCreateSubscription}
                disabled={creatingSubscription}
                className="bg-[#967d6c] text-white px-8 py-3 rounded-full poppins-text font-medium disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                {creatingSubscription ? (
                  <span className="flex items-center gap-2">
                    <span className="w-4 h-4 border-2 border-white border-b-transparent rounded-full animate-spin" />
                    Creating…
                  </span>
                ) : (
                  "Subscribe — $9.95/mo"
                )}
              </motion.button>
              {subscriptionCreationError && (
                <p className="mt-3 text-red-500 text-sm poppins-text">
                  {subscriptionCreationError}
                </p>
              )}
            </motion.div>
          )}

          {/* ── Subscription cards ── */}
          {!loading && !error && subscriptions.length > 0 && (
            <div className="space-y-5">
              {subscriptions.map((sub, i) => {
                const trialDaysLeft =
                  sub.trial_end && sub.trial_end > Date.now() / 1000
                    ? Math.ceil((sub.trial_end - Date.now() / 1000) / 86400)
                    : null;

                const nextBilling =
                  sub.status !== "canceled"
                    ? new Date(
                        sub.current_period_end * 1000,
                      ).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : null;

                return (
                  <motion.div
                    key={sub.id}
                    {...fadeUp(0.1 + i * 0.05)}
                    className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm overflow-hidden"
                  >
                    {/* Card header */}
                    <div className="bg-[#f5ede7] px-6 py-4 flex items-center justify-between">
                      <div>
                        <h2 className="text-xl font-bold text-gray-900">
                          Furbabies.AI
                        </h2>
                        <p className="text-sm text-gray-500 poppins-text">
                          Monthly plan
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-gray-900">
                          $9.95
                          <span className="text-sm font-normal text-[#967d6c] poppins-text">
                            /mo
                          </span>
                        </p>
                        <StatusBadge status={sub.status} />
                      </div>
                    </div>

                    {/* Card body */}
                    <div className="px-6 py-4">
                      <InfoRow
                        label="Payment method"
                        value={(() => {
                          const pm = sub.default_payment_method;
                          // Expanded object: { card: { last4, brand } }
                          if (pm?.card?.last4) {
                            const brand = pm.card.brand
                              ? pm.card.brand.charAt(0).toUpperCase() +
                                pm.card.brand.slice(1)
                              : "Card";
                            return `${brand} •••• ${pm.card.last4}`;
                          }
                          // Sometimes nested under payment_method directly
                          if (sub.payment_method?.card?.last4) {
                            return `•••• •••• •••• ${sub.payment_method.card.last4}`;
                          }
                          // Stripe sometimes returns last4 at top level on the sub
                          if (sub.default_payment_method?.last4) {
                            return `•••• •••• •••• ${sub.default_payment_method.last4}`;
                          }
                          // String ID only — not expanded, backend needs fixing (see note below)
                          if (typeof pm === "string" && pm.startsWith("pm_")) {
                            return "Card on file (see portal to update)";
                          }
                          return "No payment method on file";
                        })()}
                      />
                      {nextBilling && (
                        <InfoRow
                          label="Next billing date"
                          value={nextBilling}
                        />
                      )}
                      {trialDaysLeft && (
                        <InfoRow
                          label="Trial days remaining"
                          value={`${trialDaysLeft} days`}
                        />
                      )}
                    </div>

                    {/* Card actions */}
                    <div className="px-6 pb-5 pt-1">
                      {sub.status !== "canceled" ? (
                        <>
                          <motion.button
                            whileHover={{ backgroundColor: "#BDA697" }}
                            whileTap={{ scale: 0.97 }}
                            onClick={handleOpenPortal}
                            disabled={portalLoading}
                            className="w-full bg-[#967d6c] text-white py-3 rounded-xl poppins-text font-medium text-sm flex items-center justify-center gap-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
                          >
                            {portalLoading ? (
                              <>
                                <span className="w-4 h-4 border-2 border-white border-b-transparent rounded-full animate-spin" />
                                Opening portal…
                              </>
                            ) : (
                              <>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                  />
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                </svg>
                                Manage Subscription
                              </>
                            )}
                          </motion.button>
                          <p className="text-xs text-center text-gray-400 poppins-text mt-2">
                            Update payment method, cancel, or view invoices via
                            Stripe's secure portal
                          </p>
                          {portalError && (
                            <p className="mt-2 text-red-500 text-xs poppins-text text-center">
                              {portalError}
                            </p>
                          )}
                        </>
                      ) : (
                        /* ── Canceled state: resubscribe CTA inside the card ── */
                        <div className="bg-[#faf7f5] border border-[#e8ddd6] rounded-xl p-4 text-center">
                          <p className="text-sm text-gray-500 poppins-text mb-3">
                            Your subscription ended. Resubscribe anytime to
                            regain access.
                          </p>
                          <motion.button
                            whileHover={{ backgroundColor: "#BDA697" }}
                            whileTap={{ scale: 0.97 }}
                            onClick={handleCreateSubscription}
                            disabled={creatingSubscription}
                            className="w-full bg-[#967d6c] text-white py-3 rounded-xl poppins-text font-medium text-sm flex items-center justify-center gap-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
                          >
                            {creatingSubscription ? (
                              <>
                                <span className="w-4 h-4 border-2 border-white border-b-transparent rounded-full animate-spin" />
                                Redirecting to checkout…
                              </>
                            ) : (
                              <>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                  />
                                </svg>
                                Resubscribe — $9.95/mo
                              </>
                            )}
                          </motion.button>
                          {subscriptionCreationError && (
                            <p className="mt-2 text-red-500 text-xs poppins-text">
                              {subscriptionCreationError}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          )}

          {/* ── Security / Change password ── */}
          {!loading && (
            <motion.div {...fadeUp(0.2)} className="mt-5">
              <ChangePasswordForm />
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default Account;
